var map = {
	"./ReturnAddress": 173,
	"./ReturnAddress/": 173,
	"./ReturnAddress/index": 173,
	"./ReturnAddress/index.hook": 516,
	"./ReturnAddress/index.hook.js": 516,
	"./ReturnAddress/index.js": 173,
	"./TradeInItems": 387,
	"./TradeInItems/": 387,
	"./TradeInItems/Form": 374,
	"./TradeInItems/Form.js": 374,
	"./TradeInItems/form.hook": 579,
	"./TradeInItems/form.hook.js": 579,
	"./TradeInItems/index": 387,
	"./TradeInItems/index.hook": 519,
	"./TradeInItems/index.hook.js": 519,
	"./TradeInItems/index.js": 387,
	"./common/AppLayout": 85,
	"./common/AppLayout/": 85,
	"./common/AppLayout/AppLayout": 505,
	"./common/AppLayout/AppLayout.tsx": 505,
	"./common/AppLayout/index": 85,
	"./common/AppLayout/index.ts": 85,
	"./common/Draggable": 218,
	"./common/Draggable/": 218,
	"./common/Draggable/Draggable": 389,
	"./common/Draggable/Draggable.tsx": 389,
	"./common/Draggable/index": 218,
	"./common/Draggable/index.js": 218,
	"./common/Droppable": 219,
	"./common/Droppable/": 219,
	"./common/Droppable/Droppable": 390,
	"./common/Droppable/Droppable.hook": 580,
	"./common/Droppable/Droppable.hook.js": 580,
	"./common/Droppable/Droppable.jsx": 390,
	"./common/Droppable/index": 219,
	"./common/Droppable/index.js": 219,
	"./common/ErrorToast": 10,
	"./common/ErrorToast/": 10,
	"./common/ErrorToast/ErrorToast": 385,
	"./common/ErrorToast/ErrorToast.tsx": 385,
	"./common/ErrorToast/index": 10,
	"./common/ErrorToast/index.ts": 10,
	"./common/Header": 60,
	"./common/Header/": 60,
	"./common/Header/Header": 217,
	"./common/Header/Header.tsx": 217,
	"./common/Header/index": 60,
	"./common/Header/index.ts": 60,
	"./common/SubHeader": 42,
	"./common/SubHeader/": 42,
	"./common/SubHeader/SubHeader": 220,
	"./common/SubHeader/SubHeader.tsx": 220,
	"./common/SubHeader/index": 42,
	"./common/SubHeader/index.ts": 42,
	"./common/SubHeaderOld": 52,
	"./common/SubHeaderOld/": 52,
	"./common/SubHeaderOld/SubHeaderOld": 391,
	"./common/SubHeaderOld/SubHeaderOld.tsx": 391,
	"./common/SubHeaderOld/index": 52,
	"./common/SubHeaderOld/index.js": 52,
	"./common/SuccessToast": 15,
	"./common/SuccessToast/": 15,
	"./common/SuccessToast/SuccessToast": 386,
	"./common/SuccessToast/SuccessToast.jsx": 386,
	"./common/SuccessToast/index": 15,
	"./common/SuccessToast/index.js": 15,
	"./confirmation_modal/confirmation_modal": 283,
	"./confirmation_modal/confirmation_modal.js": 283,
	"./emailTemplates": 392,
	"./emailTemplates/": 392,
	"./emailTemplates/emailData": 521,
	"./emailTemplates/emailData.js": 521,
	"./emailTemplates/form": 520,
	"./emailTemplates/form.js": 520,
	"./emailTemplates/index": 392,
	"./emailTemplates/index.js": 392,
	"./header": 47,
	"./header/": 47,
	"./header/Header": 388,
	"./header/Header.jsx": 388,
	"./header/index": 47,
	"./header/index.js": 47,
	"./home": 500,
	"./home/": 500,
	"./home/index": 500,
	"./home/index.js": 500,
	"./integrations": 393,
	"./integrations/": 393,
	"./integrations/components/CollectPlus": 394,
	"./integrations/components/CollectPlus/": 394,
	"./integrations/components/CollectPlus/CollectPlus": 395,
	"./integrations/components/CollectPlus/CollectPlus.hook": 523,
	"./integrations/components/CollectPlus/CollectPlus.hook.js": 523,
	"./integrations/components/CollectPlus/CollectPlus.jsx": 395,
	"./integrations/components/CollectPlus/index": 394,
	"./integrations/components/CollectPlus/index.jsx": 394,
	"./integrations/components/Finecom": 397,
	"./integrations/components/Finecom/": 397,
	"./integrations/components/Finecom/Finecom": 398,
	"./integrations/components/Finecom/Finecom.hook": 524,
	"./integrations/components/Finecom/Finecom.hook.ts": 524,
	"./integrations/components/Finecom/Finecom.jsx": 398,
	"./integrations/components/Finecom/index": 397,
	"./integrations/components/Finecom/index.jsx": 397,
	"./integrations/components/Finecom/locales/DE.json": 789,
	"./integrations/components/Finecom/locales/EN.json": 788,
	"./integrations/components/Finecom/ui-kit/icons/FinecomLogo": 291,
	"./integrations/components/Finecom/ui-kit/icons/FinecomLogo.tsx": 291,
	"./integrations/components/Paypal": 399,
	"./integrations/components/Paypal/": 399,
	"./integrations/components/Paypal/Paypal": 506,
	"./integrations/components/Paypal/Paypal.hook": 527,
	"./integrations/components/Paypal/Paypal.hook.ts": 527,
	"./integrations/components/Paypal/Paypal.tsx": 506,
	"./integrations/components/Paypal/Paypal.types": 994,
	"./integrations/components/Paypal/Paypal.types.ts": 994,
	"./integrations/components/Paypal/Paypal.util": 210,
	"./integrations/components/Paypal/Paypal.util.ts": 210,
	"./integrations/components/Paypal/index": 399,
	"./integrations/components/Paypal/index.js": 399,
	"./integrations/components/Paypal/locales/DE.json": 793,
	"./integrations/components/Paypal/locales/EN.json": 792,
	"./integrations/components/Peoplevox": 400,
	"./integrations/components/Peoplevox/": 400,
	"./integrations/components/Peoplevox/Peoplevox": 401,
	"./integrations/components/Peoplevox/Peoplevox.hook": 528,
	"./integrations/components/Peoplevox/Peoplevox.hook.ts": 528,
	"./integrations/components/Peoplevox/Peoplevox.tsx": 401,
	"./integrations/components/Peoplevox/Peoplevox.types": 995,
	"./integrations/components/Peoplevox/Peoplevox.types.ts": 995,
	"./integrations/components/Peoplevox/Peoplevox.util": 368,
	"./integrations/components/Peoplevox/Peoplevox.util.ts": 368,
	"./integrations/components/Peoplevox/index": 400,
	"./integrations/components/Peoplevox/index.js": 400,
	"./integrations/components/Peoplevox/locales/DE.json": 795,
	"./integrations/components/Peoplevox/locales/EN.json": 794,
	"./integrations/components/Xentral": 402,
	"./integrations/components/Xentral/": 402,
	"./integrations/components/Xentral/Xentral": 403,
	"./integrations/components/Xentral/Xentral.hook": 529,
	"./integrations/components/Xentral/Xentral.hook.js": 529,
	"./integrations/components/Xentral/Xentral.jsx": 403,
	"./integrations/components/Xentral/index": 402,
	"./integrations/components/Xentral/index.jsx": 402,
	"./integrations/components/common/AppLayout": 101,
	"./integrations/components/common/AppLayout/": 101,
	"./integrations/components/common/AppLayout/AppLayout": 396,
	"./integrations/components/common/AppLayout/AppLayout.tsx": 396,
	"./integrations/components/common/AppLayout/index": 101,
	"./integrations/components/common/AppLayout/index.jsx": 101,
	"./integrations/dhl": 404,
	"./integrations/dhl/": 404,
	"./integrations/dhl/dhl.hook": 530,
	"./integrations/dhl/dhl.hook.js": 530,
	"./integrations/dhl/index": 404,
	"./integrations/dhl/index.js": 404,
	"./integrations/dhl/translations/DE.json": 797,
	"./integrations/dhl/translations/EN.json": 796,
	"./integrations/index": 393,
	"./integrations/index.js": 393,
	"./integrations/integration_card": 522,
	"./integrations/integration_card.js": 522,
	"./integrations/klaviyo": 405,
	"./integrations/klaviyo/": 405,
	"./integrations/klaviyo/index": 405,
	"./integrations/klaviyo/index.js": 405,
	"./integrations/klaviyo/klaviyo.hook": 531,
	"./integrations/klaviyo/klaviyo.hook.js": 531,
	"./integrations/public_api": 406,
	"./integrations/public_api/": 406,
	"./integrations/public_api/index": 406,
	"./integrations/public_api/index.js": 406,
	"./integrations/public_api/public_api.hook": 533,
	"./integrations/public_api/public_api.hook.js": 533,
	"./integrations/shopify": 407,
	"./integrations/shopify/": 407,
	"./integrations/shopify/index": 407,
	"./integrations/shopify/index.js": 407,
	"./integrations/shopify/shopify.hook": 534,
	"./integrations/shopify/shopify.hook.js": 534,
	"./integrations/shopware": 408,
	"./integrations/shopware/": 408,
	"./integrations/shopware/index": 408,
	"./integrations/shopware/index.js": 408,
	"./integrations/shopware/shopware.hook": 535,
	"./integrations/shopware/shopware.hook.js": 535,
	"./locale/i18n": 299,
	"./locale/i18n.js": 299,
	"./manageReturns": 409,
	"./manageReturns/": 409,
	"./manageReturns/Complete/Scayle": 417,
	"./manageReturns/Complete/Scayle/": 417,
	"./manageReturns/Complete/Scayle/Scayle": 418,
	"./manageReturns/Complete/Scayle/Scayle.jsx": 418,
	"./manageReturns/Complete/Scayle/components/Item": 174,
	"./manageReturns/Complete/Scayle/components/Item/": 174,
	"./manageReturns/Complete/Scayle/components/Item/Item": 419,
	"./manageReturns/Complete/Scayle/components/Item/Item.jsx": 419,
	"./manageReturns/Complete/Scayle/components/Item/index": 174,
	"./manageReturns/Complete/Scayle/components/Item/index.js": 174,
	"./manageReturns/Complete/Scayle/index": 417,
	"./manageReturns/Complete/Scayle/index.js": 417,
	"./manageReturns/Complete/Shopify": 420,
	"./manageReturns/Complete/Shopify/": 420,
	"./manageReturns/Complete/Shopify/Shopify": 421,
	"./manageReturns/Complete/Shopify/Shopify.jsx": 421,
	"./manageReturns/Complete/Shopify/components/CustomRefundViaOriginalPaymentMethod": 221,
	"./manageReturns/Complete/Shopify/components/CustomRefundViaOriginalPaymentMethod/": 221,
	"./manageReturns/Complete/Shopify/components/CustomRefundViaOriginalPaymentMethod/CustomRefundViaOriginalPaymentMethod": 422,
	"./manageReturns/Complete/Shopify/components/CustomRefundViaOriginalPaymentMethod/CustomRefundViaOriginalPaymentMethod.tsx": 422,
	"./manageReturns/Complete/Shopify/components/CustomRefundViaOriginalPaymentMethod/index": 221,
	"./manageReturns/Complete/Shopify/components/CustomRefundViaOriginalPaymentMethod/index.ts": 221,
	"./manageReturns/Complete/Shopify/components/Item": 160,
	"./manageReturns/Complete/Shopify/components/Item/": 160,
	"./manageReturns/Complete/Shopify/components/Item/Item": 423,
	"./manageReturns/Complete/Shopify/components/Item/Item.jsx": 423,
	"./manageReturns/Complete/Shopify/components/Item/index": 160,
	"./manageReturns/Complete/Shopify/components/Item/index.js": 160,
	"./manageReturns/Complete/Shopify/index": 420,
	"./manageReturns/Complete/Shopify/index.js": 420,
	"./manageReturns/Complete/Shopware": 424,
	"./manageReturns/Complete/Shopware/": 424,
	"./manageReturns/Complete/Shopware/Shopware": 425,
	"./manageReturns/Complete/Shopware/Shopware.jsx": 425,
	"./manageReturns/Complete/Shopware/components/Item": 206,
	"./manageReturns/Complete/Shopware/components/Item/": 206,
	"./manageReturns/Complete/Shopware/components/Item/Item": 426,
	"./manageReturns/Complete/Shopware/components/Item/Item.jsx": 426,
	"./manageReturns/Complete/Shopware/components/Item/index": 206,
	"./manageReturns/Complete/Shopware/components/Item/index.js": 206,
	"./manageReturns/Complete/Shopware/index": 424,
	"./manageReturns/Complete/Shopware/index.js": 424,
	"./manageReturns/EditReturn": 427,
	"./manageReturns/EditReturn/": 427,
	"./manageReturns/EditReturn/EditReturn": 577,
	"./manageReturns/EditReturn/EditReturn.jsx": 577,
	"./manageReturns/EditReturn/components/CreateLabelModal": 228,
	"./manageReturns/EditReturn/components/CreateLabelModal/": 228,
	"./manageReturns/EditReturn/components/CreateLabelModal/CreateLabelModal": 503,
	"./manageReturns/EditReturn/components/CreateLabelModal/CreateLabelModal.jsx": 503,
	"./manageReturns/EditReturn/components/CreateLabelModal/index": 228,
	"./manageReturns/EditReturn/components/CreateLabelModal/index.js": 228,
	"./manageReturns/EditReturn/components/InstantStoreCreditAuthorizedPaymentModal": 229,
	"./manageReturns/EditReturn/components/InstantStoreCreditAuthorizedPaymentModal/": 229,
	"./manageReturns/EditReturn/components/InstantStoreCreditAuthorizedPaymentModal/InstantStoreCreditAuthorizedPaymentModal": 433,
	"./manageReturns/EditReturn/components/InstantStoreCreditAuthorizedPaymentModal/InstantStoreCreditAuthorizedPaymentModal.tsx": 433,
	"./manageReturns/EditReturn/components/InstantStoreCreditAuthorizedPaymentModal/index": 229,
	"./manageReturns/EditReturn/components/InstantStoreCreditAuthorizedPaymentModal/index.js": 229,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal": 230,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/": 230,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/InstantStoreCreditCaptureAuthorizedPaymentModal": 434,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/InstantStoreCreditCaptureAuthorizedPaymentModal.hook": 543,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/InstantStoreCreditCaptureAuthorizedPaymentModal.hook.ts": 543,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/InstantStoreCreditCaptureAuthorizedPaymentModal.tsx": 434,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/index": 230,
	"./manageReturns/EditReturn/components/InstantStoreCreditCaptureAuthorizedPaymentModal/index.js": 230,
	"./manageReturns/EditReturn/components/ReturnCloseModal/ReturnCloseModal": 542,
	"./manageReturns/EditReturn/components/ReturnCloseModal/ReturnCloseModal.tsx": 542,
	"./manageReturns/EditReturn/components/ReturnHistory": 226,
	"./manageReturns/EditReturn/components/ReturnHistory/": 226,
	"./manageReturns/EditReturn/components/ReturnHistory/ReturnHistory": 431,
	"./manageReturns/EditReturn/components/ReturnHistory/ReturnHistory.jsx": 431,
	"./manageReturns/EditReturn/components/ReturnHistory/index": 226,
	"./manageReturns/EditReturn/components/ReturnHistory/index.js": 226,
	"./manageReturns/EditReturn/components/ReturnStatus": 222,
	"./manageReturns/EditReturn/components/ReturnStatus/": 222,
	"./manageReturns/EditReturn/components/ReturnStatus/ReturnStatus": 499,
	"./manageReturns/EditReturn/components/ReturnStatus/ReturnStatus.jsx": 499,
	"./manageReturns/EditReturn/components/ReturnStatus/index": 222,
	"./manageReturns/EditReturn/components/ReturnStatus/index.js": 222,
	"./manageReturns/EditReturn/components/SaveNote": 225,
	"./manageReturns/EditReturn/components/SaveNote/": 225,
	"./manageReturns/EditReturn/components/SaveNote/SaveNote": 430,
	"./manageReturns/EditReturn/components/SaveNote/SaveNote.jsx": 430,
	"./manageReturns/EditReturn/components/SaveNote/index": 225,
	"./manageReturns/EditReturn/components/SaveNote/index.js": 225,
	"./manageReturns/EditReturn/components/ShowReturn": 88,
	"./manageReturns/EditReturn/components/ShowReturn/": 88,
	"./manageReturns/EditReturn/components/ShowReturn/ShowReturn": 432,
	"./manageReturns/EditReturn/components/ShowReturn/ShowReturn.jsx": 432,
	"./manageReturns/EditReturn/components/ShowReturn/index": 88,
	"./manageReturns/EditReturn/components/ShowReturn/index.js": 88,
	"./manageReturns/EditReturn/components/ShowReturnItem": 223,
	"./manageReturns/EditReturn/components/ShowReturnItem/": 223,
	"./manageReturns/EditReturn/components/ShowReturnItem/ShowReturnItem": 428,
	"./manageReturns/EditReturn/components/ShowReturnItem/ShowReturnItem.hook": 540,
	"./manageReturns/EditReturn/components/ShowReturnItem/ShowReturnItem.hook.js": 540,
	"./manageReturns/EditReturn/components/ShowReturnItem/ShowReturnItem.jsx": 428,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/Item": 207,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/Item/": 207,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/Item/Item": 502,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/Item/Item.jsx": 502,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/Item/index": 207,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/Item/index.js": 207,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/ItemFieldDropdown": 208,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/ItemFieldDropdown/": 208,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/ItemFieldDropdown/ItemFieldDropdown": 429,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/ItemFieldDropdown/ItemFieldDropdown.jsx": 429,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/ItemFieldDropdown/index": 208,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/ItemFieldDropdown/index.js": 208,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/TopLevelItem": 224,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/TopLevelItem/": 224,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/TopLevelItem/TopLevelItem": 501,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/TopLevelItem/TopLevelItem.jsx": 501,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/TopLevelItem/index": 224,
	"./manageReturns/EditReturn/components/ShowReturnItem/components/TopLevelItem/index.js": 224,
	"./manageReturns/EditReturn/components/ShowReturnItem/index": 223,
	"./manageReturns/EditReturn/components/ShowReturnItem/index.js": 223,
	"./manageReturns/EditReturn/components/SideBar": 227,
	"./manageReturns/EditReturn/components/SideBar/": 227,
	"./manageReturns/EditReturn/components/SideBar/SideBar": 497,
	"./manageReturns/EditReturn/components/SideBar/SideBar.hook": 541,
	"./manageReturns/EditReturn/components/SideBar/SideBar.hook.js": 541,
	"./manageReturns/EditReturn/components/SideBar/SideBar.jsx": 497,
	"./manageReturns/EditReturn/components/SideBar/index": 227,
	"./manageReturns/EditReturn/components/SideBar/index.js": 227,
	"./manageReturns/EditReturn/components/UnregisteredItems": 231,
	"./manageReturns/EditReturn/components/UnregisteredItems/": 231,
	"./manageReturns/EditReturn/components/UnregisteredItems/UnregisteredItem": 435,
	"./manageReturns/EditReturn/components/UnregisteredItems/UnregisteredItem.jsx": 435,
	"./manageReturns/EditReturn/components/UnregisteredItems/index": 231,
	"./manageReturns/EditReturn/components/UnregisteredItems/index.js": 231,
	"./manageReturns/EditReturn/index": 427,
	"./manageReturns/EditReturn/index.js": 427,
	"./manageReturns/Register/Scayle": 436,
	"./manageReturns/Register/Scayle/": 436,
	"./manageReturns/Register/Scayle/Scayle": 437,
	"./manageReturns/Register/Scayle/Scayle.hook": 544,
	"./manageReturns/Register/Scayle/Scayle.hook.tsx": 544,
	"./manageReturns/Register/Scayle/Scayle.tsx": 437,
	"./manageReturns/Register/Scayle/Scayle.types": 165,
	"./manageReturns/Register/Scayle/Scayle.types.ts": 165,
	"./manageReturns/Register/Scayle/components/ReturnReason": 233,
	"./manageReturns/Register/Scayle/components/ReturnReason/": 233,
	"./manageReturns/Register/Scayle/components/ReturnReason/ReturnReason": 439,
	"./manageReturns/Register/Scayle/components/ReturnReason/ReturnReason.tsx": 439,
	"./manageReturns/Register/Scayle/components/ReturnReason/index": 233,
	"./manageReturns/Register/Scayle/components/ReturnReason/index.ts": 233,
	"./manageReturns/Register/Scayle/components/SearchOrder": 234,
	"./manageReturns/Register/Scayle/components/SearchOrder/": 234,
	"./manageReturns/Register/Scayle/components/SearchOrder/SearchOrder": 440,
	"./manageReturns/Register/Scayle/components/SearchOrder/SearchOrder.tsx": 440,
	"./manageReturns/Register/Scayle/components/SearchOrder/index": 234,
	"./manageReturns/Register/Scayle/components/SearchOrder/index.ts": 234,
	"./manageReturns/Register/Scayle/components/Table": 232,
	"./manageReturns/Register/Scayle/components/Table/": 232,
	"./manageReturns/Register/Scayle/components/Table/Table": 438,
	"./manageReturns/Register/Scayle/components/Table/Table.tsx": 438,
	"./manageReturns/Register/Scayle/components/Table/index": 232,
	"./manageReturns/Register/Scayle/components/Table/index.ts": 232,
	"./manageReturns/Register/Scayle/index": 436,
	"./manageReturns/Register/Scayle/index.ts": 436,
	"./manageReturns/Register/Scayle/translations/DE.json": 799,
	"./manageReturns/Register/Scayle/translations/EN.json": 798,
	"./manageReturns/Register/Shopify": 441,
	"./manageReturns/Register/Shopify/": 441,
	"./manageReturns/Register/Shopify/Shopify": 442,
	"./manageReturns/Register/Shopify/Shopify.hook": 545,
	"./manageReturns/Register/Shopify/Shopify.hook.tsx": 545,
	"./manageReturns/Register/Shopify/Shopify.tsx": 442,
	"./manageReturns/Register/Shopify/Shopify.types": 166,
	"./manageReturns/Register/Shopify/Shopify.types.ts": 166,
	"./manageReturns/Register/Shopify/components/ReturnReason": 236,
	"./manageReturns/Register/Shopify/components/ReturnReason/": 236,
	"./manageReturns/Register/Shopify/components/ReturnReason/ReturnReason": 444,
	"./manageReturns/Register/Shopify/components/ReturnReason/ReturnReason.tsx": 444,
	"./manageReturns/Register/Shopify/components/ReturnReason/index": 236,
	"./manageReturns/Register/Shopify/components/ReturnReason/index.ts": 236,
	"./manageReturns/Register/Shopify/components/SearchOrder": 237,
	"./manageReturns/Register/Shopify/components/SearchOrder/": 237,
	"./manageReturns/Register/Shopify/components/SearchOrder/SearchOrder": 445,
	"./manageReturns/Register/Shopify/components/SearchOrder/SearchOrder.tsx": 445,
	"./manageReturns/Register/Shopify/components/SearchOrder/index": 237,
	"./manageReturns/Register/Shopify/components/SearchOrder/index.ts": 237,
	"./manageReturns/Register/Shopify/components/Table": 235,
	"./manageReturns/Register/Shopify/components/Table/": 235,
	"./manageReturns/Register/Shopify/components/Table/Table": 443,
	"./manageReturns/Register/Shopify/components/Table/Table.tsx": 443,
	"./manageReturns/Register/Shopify/components/Table/index": 235,
	"./manageReturns/Register/Shopify/components/Table/index.ts": 235,
	"./manageReturns/Register/Shopify/index": 441,
	"./manageReturns/Register/Shopify/index.ts": 441,
	"./manageReturns/Register/Shopify/translations/DE.json": 801,
	"./manageReturns/Register/Shopify/translations/EN.json": 800,
	"./manageReturns/customer_returns_export": 536,
	"./manageReturns/customer_returns_export.js": 536,
	"./manageReturns/customer_returns_import_modal": 537,
	"./manageReturns/customer_returns_import_modal.js": 537,
	"./manageReturns/index": 409,
	"./manageReturns/index.js": 409,
	"./manageReturns/table": 578,
	"./manageReturns/table.js": 578,
	"./manageUsers": 446,
	"./manageUsers/": 446,
	"./manageUsers/components/DeleteModal": 240,
	"./manageUsers/components/DeleteModal/": 240,
	"./manageUsers/components/DeleteModal/DeleteModal": 449,
	"./manageUsers/components/DeleteModal/DeleteModal.jsx": 449,
	"./manageUsers/components/DeleteModal/index": 240,
	"./manageUsers/components/DeleteModal/index.js": 240,
	"./manageUsers/components/UpdateRoleModal": 239,
	"./manageUsers/components/UpdateRoleModal/": 239,
	"./manageUsers/components/UpdateRoleModal/UpdateRoleModal": 448,
	"./manageUsers/components/UpdateRoleModal/UpdateRoleModal.jsx": 448,
	"./manageUsers/components/UpdateRoleModal/index": 239,
	"./manageUsers/components/UpdateRoleModal/index.js": 239,
	"./manageUsers/components/User": 238,
	"./manageUsers/components/User/": 238,
	"./manageUsers/components/User/User": 447,
	"./manageUsers/components/User/User.jsx": 447,
	"./manageUsers/components/User/index": 238,
	"./manageUsers/components/User/index.js": 238,
	"./manageUsers/index": 446,
	"./manageUsers/index.js": 446,
	"./merchantLanguages": 507,
	"./merchantLanguages/": 507,
	"./merchantLanguages/CustomReturnSection": 547,
	"./merchantLanguages/CustomReturnSection.js": 547,
	"./merchantLanguages/components/InstantStoreCredit": 247,
	"./merchantLanguages/components/InstantStoreCredit/": 247,
	"./merchantLanguages/components/InstantStoreCredit/InstantStoreCredit": 456,
	"./merchantLanguages/components/InstantStoreCredit/InstantStoreCredit.hook": 553,
	"./merchantLanguages/components/InstantStoreCredit/InstantStoreCredit.hook.js": 553,
	"./merchantLanguages/components/InstantStoreCredit/InstantStoreCredit.jsx": 456,
	"./merchantLanguages/components/InstantStoreCredit/index": 247,
	"./merchantLanguages/components/InstantStoreCredit/index.js": 247,
	"./merchantLanguages/components/ItemSelection": 242,
	"./merchantLanguages/components/ItemSelection/": 242,
	"./merchantLanguages/components/ItemSelection/ItemSelection": 451,
	"./merchantLanguages/components/ItemSelection/ItemSelection.hook": 549,
	"./merchantLanguages/components/ItemSelection/ItemSelection.hook.js": 549,
	"./merchantLanguages/components/ItemSelection/ItemSelection.jsx": 451,
	"./merchantLanguages/components/ItemSelection/index": 242,
	"./merchantLanguages/components/ItemSelection/index.js": 242,
	"./merchantLanguages/components/LoginPage": 241,
	"./merchantLanguages/components/LoginPage/": 241,
	"./merchantLanguages/components/LoginPage/LoginPage": 450,
	"./merchantLanguages/components/LoginPage/LoginPage.hook": 548,
	"./merchantLanguages/components/LoginPage/LoginPage.hook.js": 548,
	"./merchantLanguages/components/LoginPage/LoginPage.jsx": 450,
	"./merchantLanguages/components/LoginPage/index": 241,
	"./merchantLanguages/components/LoginPage/index.js": 241,
	"./merchantLanguages/components/OtherSettings": 249,
	"./merchantLanguages/components/OtherSettings/": 249,
	"./merchantLanguages/components/OtherSettings/OtherSettings": 458,
	"./merchantLanguages/components/OtherSettings/OtherSettings.jsx": 458,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage": 250,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/": 250,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/DeleteLanguage": 459,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/DeleteLanguage.jsx": 459,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/components/DeleteModal": 251,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/components/DeleteModal/": 251,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/components/DeleteModal/DeleteModal": 460,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/components/DeleteModal/DeleteModal.jsx": 460,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/components/DeleteModal/index": 251,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/components/DeleteModal/index.js": 251,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/index": 250,
	"./merchantLanguages/components/OtherSettings/components/DeleteLanguage/index.js": 250,
	"./merchantLanguages/components/OtherSettings/components/OtherSettingsSection": 303,
	"./merchantLanguages/components/OtherSettings/components/OtherSettingsSection.js": 303,
	"./merchantLanguages/components/OtherSettings/index": 249,
	"./merchantLanguages/components/OtherSettings/index.js": 249,
	"./merchantLanguages/components/Overview": 244,
	"./merchantLanguages/components/Overview/": 244,
	"./merchantLanguages/components/Overview/Overview": 453,
	"./merchantLanguages/components/Overview/Overview.hook": 551,
	"./merchantLanguages/components/Overview/Overview.hook.js": 551,
	"./merchantLanguages/components/Overview/Overview.jsx": 453,
	"./merchantLanguages/components/Overview/index": 244,
	"./merchantLanguages/components/Overview/index.js": 244,
	"./merchantLanguages/components/RefundTypeSelection": 246,
	"./merchantLanguages/components/RefundTypeSelection/": 246,
	"./merchantLanguages/components/RefundTypeSelection/RefundTypeSelection": 455,
	"./merchantLanguages/components/RefundTypeSelection/RefundTypeSelection.hook": 552,
	"./merchantLanguages/components/RefundTypeSelection/RefundTypeSelection.hook.js": 552,
	"./merchantLanguages/components/RefundTypeSelection/RefundTypeSelection.jsx": 455,
	"./merchantLanguages/components/RefundTypeSelection/index": 246,
	"./merchantLanguages/components/RefundTypeSelection/index.js": 246,
	"./merchantLanguages/components/ReturnConfirmationPage": 248,
	"./merchantLanguages/components/ReturnConfirmationPage/": 248,
	"./merchantLanguages/components/ReturnConfirmationPage/ReturnConfirmationPage": 457,
	"./merchantLanguages/components/ReturnConfirmationPage/ReturnConfirmationPage.hook": 554,
	"./merchantLanguages/components/ReturnConfirmationPage/ReturnConfirmationPage.hook.js": 554,
	"./merchantLanguages/components/ReturnConfirmationPage/ReturnConfirmationPage.jsx": 457,
	"./merchantLanguages/components/ReturnConfirmationPage/index": 248,
	"./merchantLanguages/components/ReturnConfirmationPage/index.js": 248,
	"./merchantLanguages/components/ReturnMethodSelection": 243,
	"./merchantLanguages/components/ReturnMethodSelection/": 243,
	"./merchantLanguages/components/ReturnMethodSelection/ReturnMethodSelection": 452,
	"./merchantLanguages/components/ReturnMethodSelection/ReturnMethodSelection.hook": 550,
	"./merchantLanguages/components/ReturnMethodSelection/ReturnMethodSelection.hook.js": 550,
	"./merchantLanguages/components/ReturnMethodSelection/ReturnMethodSelection.jsx": 452,
	"./merchantLanguages/components/ReturnMethodSelection/index": 243,
	"./merchantLanguages/components/ReturnMethodSelection/index.js": 243,
	"./merchantLanguages/components/ToastMessages": 245,
	"./merchantLanguages/components/ToastMessages/": 245,
	"./merchantLanguages/components/ToastMessages/ToastMessages": 454,
	"./merchantLanguages/components/ToastMessages/ToastMessages.jsx": 454,
	"./merchantLanguages/components/ToastMessages/index": 245,
	"./merchantLanguages/components/ToastMessages/index.js": 245,
	"./merchantLanguages/form": 546,
	"./merchantLanguages/form.js": 546,
	"./merchantLanguages/index": 507,
	"./merchantLanguages/index.js": 507,
	"./missionControl": 461,
	"./missionControl/": 461,
	"./missionControl/components/CustomerReturnSearch": 559,
	"./missionControl/components/CustomerReturnSearch.js": 559,
	"./missionControl/components/EmailAndInvoiceSearch": 558,
	"./missionControl/components/EmailAndInvoiceSearch.js": 558,
	"./missionControl/components/RemoveShopifyIntegration": 560,
	"./missionControl/components/RemoveShopifyIntegration.js": 560,
	"./missionControl/components/SearchForm": 555,
	"./missionControl/components/SearchForm.js": 555,
	"./missionControl/components/SearchInput": 53,
	"./missionControl/components/SearchInput.js": 53,
	"./missionControl/components/SearchTypeSelect": 556,
	"./missionControl/components/SearchTypeSelect.js": 556,
	"./missionControl/components/ShopifyOrderIdSearch": 557,
	"./missionControl/components/ShopifyOrderIdSearch.js": 557,
	"./missionControl/components/UpdateSubdomain": 561,
	"./missionControl/components/UpdateSubdomain.js": 561,
	"./missionControl/components/addSendcloudCarrier": 562,
	"./missionControl/components/addSendcloudCarrier.js": 562,
	"./missionControl/components/addSendcloudIntegration": 563,
	"./missionControl/components/addSendcloudIntegration.js": 563,
	"./missionControl/components/addSevenSendersCarrier": 565,
	"./missionControl/components/addSevenSendersCarrier.js": 565,
	"./missionControl/components/addSevenSendersIntegration": 564,
	"./missionControl/components/addSevenSendersIntegration.js": 564,
	"./missionControl/index": 461,
	"./missionControl/index.js": 461,
	"./notification": 56,
	"./notification/": 56,
	"./notification/authentication": 1009,
	"./notification/authentication.js": 1009,
	"./notification/index": 56,
	"./notification/index.js": 56,
	"./notification/undo_action": 371,
	"./notification/undo_action.js": 371,
	"./onboarding": 462,
	"./onboarding/": 462,
	"./onboarding/components/checkListItem": 252,
	"./onboarding/components/checkListItem/": 252,
	"./onboarding/components/checkListItem/checkListItem": 508,
	"./onboarding/components/checkListItem/checkListItem.jsx": 508,
	"./onboarding/components/checkListItem/index": 252,
	"./onboarding/components/checkListItem/index.js": 252,
	"./onboarding/index": 462,
	"./onboarding/index.js": 462,
	"./policySettings": 509,
	"./policySettings/": 509,
	"./policySettings/components/BlockAndAllowSettings": 261,
	"./policySettings/components/BlockAndAllowSettings/": 261,
	"./policySettings/components/BlockAndAllowSettings/BlockAndAllowSettings": 470,
	"./policySettings/components/BlockAndAllowSettings/BlockAndAllowSettings.jsx": 470,
	"./policySettings/components/BlockAndAllowSettings/index": 261,
	"./policySettings/components/BlockAndAllowSettings/index.js": 261,
	"./policySettings/components/CustomReturnSettings": 264,
	"./policySettings/components/CustomReturnSettings/": 264,
	"./policySettings/components/CustomReturnSettings/CustomReturnSettings": 473,
	"./policySettings/components/CustomReturnSettings/CustomReturnSettings.jsx": 473,
	"./policySettings/components/CustomReturnSettings/index": 264,
	"./policySettings/components/CustomReturnSettings/index.js": 264,
	"./policySettings/components/ExchangeSettings": 263,
	"./policySettings/components/ExchangeSettings/": 263,
	"./policySettings/components/ExchangeSettings/ExchangeSettings": 472,
	"./policySettings/components/ExchangeSettings/ExchangeSettings.jsx": 472,
	"./policySettings/components/ExchangeSettings/components/ExchangeOption": 475,
	"./policySettings/components/ExchangeSettings/components/ExchangeOption/": 475,
	"./policySettings/components/ExchangeSettings/components/ExchangeOption/ExchangeOption": 476,
	"./policySettings/components/ExchangeSettings/components/ExchangeOption/ExchangeOption.jsx": 476,
	"./policySettings/components/ExchangeSettings/components/ExchangeOption/index": 475,
	"./policySettings/components/ExchangeSettings/components/ExchangeOption/index.js": 475,
	"./policySettings/components/ExchangeSettings/index": 263,
	"./policySettings/components/ExchangeSettings/index.js": 263,
	"./policySettings/components/ItemConditions": 260,
	"./policySettings/components/ItemConditions/": 260,
	"./policySettings/components/ItemConditions/ItemConditions": 469,
	"./policySettings/components/ItemConditions/ItemConditions.jsx": 469,
	"./policySettings/components/ItemConditions/index": 260,
	"./policySettings/components/ItemConditions/index.js": 260,
	"./policySettings/components/PartialRefundSettings": 254,
	"./policySettings/components/PartialRefundSettings/": 254,
	"./policySettings/components/PartialRefundSettings/PartialRefundSettings": 464,
	"./policySettings/components/PartialRefundSettings/PartialRefundSettings.jsx": 464,
	"./policySettings/components/PartialRefundSettings/components/RulesList": 255,
	"./policySettings/components/PartialRefundSettings/components/RulesList/": 255,
	"./policySettings/components/PartialRefundSettings/components/RulesList/RulesList": 465,
	"./policySettings/components/PartialRefundSettings/components/RulesList/RulesList.jsx": 465,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule": 256,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/": 256,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/Rule": 466,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/Rule.jsx": 466,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/Rule.types": 296,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/Rule.types.ts": 296,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags": 257,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/": 257,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/ItemTags": 504,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/ItemTags.hook": 566,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/ItemTags.hook.ts": 566,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/ItemTags.jsx": 504,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/index": 257,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ItemTags/index.js": 257,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value": 259,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/": 259,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/Value": 468,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/Value.hook": 567,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/Value.hook.js": 567,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/Value.jsx": 468,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/index": 259,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/Value/index.js": 259,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType": 258,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/": 258,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/ValueType": 467,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/ValueType.hook": 581,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/ValueType.hook.js": 581,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/ValueType.jsx": 467,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/index": 258,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/components/ValueType/index.js": 258,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/index": 256,
	"./policySettings/components/PartialRefundSettings/components/RulesList/components/Rule/index.js": 256,
	"./policySettings/components/PartialRefundSettings/components/RulesList/index": 255,
	"./policySettings/components/PartialRefundSettings/components/RulesList/index.js": 255,
	"./policySettings/components/PartialRefundSettings/index": 254,
	"./policySettings/components/PartialRefundSettings/index.js": 254,
	"./policySettings/components/RefundSettings": 253,
	"./policySettings/components/RefundSettings/": 253,
	"./policySettings/components/RefundSettings/RefundSettings": 463,
	"./policySettings/components/RefundSettings/RefundSettings.jsx": 463,
	"./policySettings/components/RefundSettings/index": 253,
	"./policySettings/components/RefundSettings/index.js": 253,
	"./policySettings/components/TradeInItemSettings": 265,
	"./policySettings/components/TradeInItemSettings/": 265,
	"./policySettings/components/TradeInItemSettings/TradeInItemSettings": 474,
	"./policySettings/components/TradeInItemSettings/TradeInItemSettings.hook": 568,
	"./policySettings/components/TradeInItemSettings/TradeInItemSettings.hook.js": 568,
	"./policySettings/components/TradeInItemSettings/TradeInItemSettings.jsx": 474,
	"./policySettings/components/TradeInItemSettings/index": 265,
	"./policySettings/components/TradeInItemSettings/index.js": 265,
	"./policySettings/components/WorkflowAutomation": 262,
	"./policySettings/components/WorkflowAutomation/": 262,
	"./policySettings/components/WorkflowAutomation/WorkflowAutomation": 471,
	"./policySettings/components/WorkflowAutomation/WorkflowAutomation.jsx": 471,
	"./policySettings/components/WorkflowAutomation/index": 262,
	"./policySettings/components/WorkflowAutomation/index.js": 262,
	"./policySettings/index": 509,
	"./policySettings/index.js": 509,
	"./returnMethods": 477,
	"./returnMethods/": 477,
	"./returnMethods/components/AddReturnMethod": 266,
	"./returnMethods/components/AddReturnMethod/": 266,
	"./returnMethods/components/AddReturnMethod/AddReturnMethod": 478,
	"./returnMethods/components/AddReturnMethod/AddReturnMethod.hook": 569,
	"./returnMethods/components/AddReturnMethod/AddReturnMethod.hook.js": 569,
	"./returnMethods/components/AddReturnMethod/AddReturnMethod.jsx": 478,
	"./returnMethods/components/AddReturnMethod/index": 266,
	"./returnMethods/components/AddReturnMethod/index.js": 266,
	"./returnMethods/form": 1010,
	"./returnMethods/form.js": 1010,
	"./returnMethods/index": 477,
	"./returnMethods/index.js": 477,
	"./returnPortals/return_portals": 1014,
	"./returnPortals/return_portals.js": 1014,
	"./returnReasons": 479,
	"./returnReasons/": 479,
	"./returnReasons/components/ReturnSource": 267,
	"./returnReasons/components/ReturnSource/": 267,
	"./returnReasons/components/ReturnSource/ReturnSource": 480,
	"./returnReasons/components/ReturnSource/ReturnSource.tsx": 480,
	"./returnReasons/components/ReturnSource/index": 267,
	"./returnReasons/components/ReturnSource/index.ts": 267,
	"./returnReasons/form": 372,
	"./returnReasons/form.jsx": 372,
	"./returnReasons/index": 479,
	"./returnReasons/index.jsx": 479,
	"./rules": 481,
	"./rules/": 481,
	"./rules/condition": 570,
	"./rules/condition.js": 570,
	"./rules/form": 373,
	"./rules/form.js": 373,
	"./rules/index": 481,
	"./rules/index.js": 481,
	"./services/api": 25,
	"./services/api.ts": 25,
	"./shopNowSettings": 510,
	"./shopNowSettings/": 510,
	"./shopNowSettings/components/FreeTrialScreen": 572,
	"./shopNowSettings/components/FreeTrialScreen.js": 572,
	"./shopNowSettings/index": 510,
	"./shopNowSettings/index.hook": 571,
	"./shopNowSettings/index.hook.js": 571,
	"./shopNowSettings/index.js": 510,
	"./storeCreditSettings": 511,
	"./storeCreditSettings/": 511,
	"./storeCreditSettings/components/FreeTrialScreen": 268,
	"./storeCreditSettings/components/FreeTrialScreen/": 268,
	"./storeCreditSettings/components/FreeTrialScreen/FreeTrialScreen": 482,
	"./storeCreditSettings/components/FreeTrialScreen/FreeTrialScreen.jsx": 482,
	"./storeCreditSettings/components/FreeTrialScreen/index": 268,
	"./storeCreditSettings/components/FreeTrialScreen/index.js": 268,
	"./storeCreditSettings/components/SettingScreen": 269,
	"./storeCreditSettings/components/SettingScreen/": 269,
	"./storeCreditSettings/components/SettingScreen/index": 269,
	"./storeCreditSettings/components/SettingScreen/index.js": 269,
	"./storeCreditSettings/components/SettingScreen/settingScreen": 483,
	"./storeCreditSettings/components/SettingScreen/settingScreen.jsx": 483,
	"./storeCreditSettings/index": 511,
	"./storeCreditSettings/index.hook": 573,
	"./storeCreditSettings/index.hook.js": 573,
	"./storeCreditSettings/index.js": 511,
	"./superadmin/components/MerchantSetting": 97,
	"./superadmin/components/MerchantSetting/": 97,
	"./superadmin/components/MerchantSetting/MerchantSetting": 484,
	"./superadmin/components/MerchantSetting/MerchantSetting.jsx": 484,
	"./superadmin/components/MerchantSetting/index": 97,
	"./superadmin/components/MerchantSetting/index.js": 97,
	"./superadmin/hooks/useCheckoutV3ToggleState": 270,
	"./superadmin/hooks/useCheckoutV3ToggleState/": 270,
	"./superadmin/hooks/useCheckoutV3ToggleState/index": 270,
	"./superadmin/hooks/useCheckoutV3ToggleState/index.js": 270,
	"./superadmin/hooks/useCheckoutV3ToggleState/useCheckoutV3ToggleState": 485,
	"./superadmin/hooks/useCheckoutV3ToggleState/useCheckoutV3ToggleState.js": 485,
	"./superadmin/hooks/useCreateManualReturnToggleState": 271,
	"./superadmin/hooks/useCreateManualReturnToggleState/": 271,
	"./superadmin/hooks/useCreateManualReturnToggleState/index": 271,
	"./superadmin/hooks/useCreateManualReturnToggleState/index.js": 271,
	"./superadmin/hooks/useCreateManualReturnToggleState/useCreateManualReturnToggleState": 486,
	"./superadmin/hooks/useCreateManualReturnToggleState/useCreateManualReturnToggleState.js": 486,
	"./superadmin/hooks/useCustomReturnsToggleState": 272,
	"./superadmin/hooks/useCustomReturnsToggleState/": 272,
	"./superadmin/hooks/useCustomReturnsToggleState/index": 272,
	"./superadmin/hooks/useCustomReturnsToggleState/index.js": 272,
	"./superadmin/hooks/useCustomReturnsToggleState/useCustomReturnsToggleState": 487,
	"./superadmin/hooks/useCustomReturnsToggleState/useCustomReturnsToggleState.js": 487,
	"./superadmin/hooks/useExchangeReturnsToggleState": 273,
	"./superadmin/hooks/useExchangeReturnsToggleState/": 273,
	"./superadmin/hooks/useExchangeReturnsToggleState/index": 273,
	"./superadmin/hooks/useExchangeReturnsToggleState/index.js": 273,
	"./superadmin/hooks/useExchangeReturnsToggleState/useExchangeReturnsToggleState": 488,
	"./superadmin/hooks/useExchangeReturnsToggleState/useExchangeReturnsToggleState.js": 488,
	"./superadmin/hooks/useFinecomToggleState": 489,
	"./superadmin/hooks/useFinecomToggleState/": 489,
	"./superadmin/hooks/useFinecomToggleState/index": 489,
	"./superadmin/hooks/useFinecomToggleState/index.js": 489,
	"./superadmin/hooks/useFinecomToggleState/useFinecomToggleState": 274,
	"./superadmin/hooks/useFinecomToggleState/useFinecomToggleState.js": 274,
	"./superadmin/hooks/useKlaviyoToggleState": 275,
	"./superadmin/hooks/useKlaviyoToggleState/": 275,
	"./superadmin/hooks/useKlaviyoToggleState/index": 275,
	"./superadmin/hooks/useKlaviyoToggleState/index.js": 275,
	"./superadmin/hooks/useKlaviyoToggleState/useKlaviyoToggleState": 490,
	"./superadmin/hooks/useKlaviyoToggleState/useKlaviyoToggleState.js": 490,
	"./superadmin/hooks/useMerchantSettingStates": 276,
	"./superadmin/hooks/useMerchantSettingStates/": 276,
	"./superadmin/hooks/useMerchantSettingStates/index": 276,
	"./superadmin/hooks/useMerchantSettingStates/index.js": 276,
	"./superadmin/hooks/useMerchantSettingStates/useMerchantSettingStates": 491,
	"./superadmin/hooks/useMerchantSettingStates/useMerchantSettingStates.js": 491,
	"./superadmin/hooks/useOnStoreExchangeToggleState": 279,
	"./superadmin/hooks/useOnStoreExchangeToggleState/": 279,
	"./superadmin/hooks/useOnStoreExchangeToggleState/index": 279,
	"./superadmin/hooks/useOnStoreExchangeToggleState/index.js": 279,
	"./superadmin/hooks/useOnStoreExchangeToggleState/useOnStoreExchangeToggleState": 494,
	"./superadmin/hooks/useOnStoreExchangeToggleState/useOnStoreExchangeToggleState.js": 494,
	"./superadmin/hooks/useOnboardingAssistantState": 281,
	"./superadmin/hooks/useOnboardingAssistantState/": 281,
	"./superadmin/hooks/useOnboardingAssistantState/index": 281,
	"./superadmin/hooks/useOnboardingAssistantState/index.js": 281,
	"./superadmin/hooks/useOnboardingAssistantState/useOnboardingAssistantState": 496,
	"./superadmin/hooks/useOnboardingAssistantState/useOnboardingAssistantState.js": 496,
	"./superadmin/hooks/usePaywallToggleState": 280,
	"./superadmin/hooks/usePaywallToggleState/": 280,
	"./superadmin/hooks/usePaywallToggleState/index": 280,
	"./superadmin/hooks/usePaywallToggleState/index.js": 280,
	"./superadmin/hooks/usePaywallToggleState/usePaywallToggleState": 495,
	"./superadmin/hooks/usePaywallToggleState/usePaywallToggleState.js": 495,
	"./superadmin/hooks/usePaywallToggleState/usePaywallToggleState.util": 304,
	"./superadmin/hooks/usePaywallToggleState/usePaywallToggleState.util.ts": 304,
	"./superadmin/hooks/usePeoplevoxToggleState": 278,
	"./superadmin/hooks/usePeoplevoxToggleState/": 278,
	"./superadmin/hooks/usePeoplevoxToggleState/index": 278,
	"./superadmin/hooks/usePeoplevoxToggleState/index.js": 278,
	"./superadmin/hooks/usePeoplevoxToggleState/usePeoplevoxToggleState": 493,
	"./superadmin/hooks/usePeoplevoxToggleState/usePeoplevoxToggleState.js": 493,
	"./superadmin/hooks/useXentralToggleState": 277,
	"./superadmin/hooks/useXentralToggleState/": 277,
	"./superadmin/hooks/useXentralToggleState/index": 277,
	"./superadmin/hooks/useXentralToggleState/index.js": 277,
	"./superadmin/hooks/useXentralToggleState/useXentralToggleState": 492,
	"./superadmin/hooks/useXentralToggleState/useXentralToggleState.js": 492,
	"./superadmin/superadmin": 1015,
	"./superadmin/superadmin.hook": 574,
	"./superadmin/superadmin.hook.js": 574,
	"./superadmin/superadmin.js": 1015,
	"./ui-kit/icons/CollectPlusLogo": 289,
	"./ui-kit/icons/CollectPlusLogo.jsx": 289,
	"./ui-kit/icons/DateArrowIcon": 370,
	"./ui-kit/icons/DateArrowIcon.jsx": 370,
	"./ui-kit/icons/FilterDateIcon": 539,
	"./ui-kit/icons/FilterDateIcon.jsx": 539,
	"./ui-kit/icons/LeftArrowIcon": 293,
	"./ui-kit/icons/LeftArrowIcon.jsx": 293,
	"./ui-kit/icons/ManageReturnIcon": 538,
	"./ui-kit/icons/ManageReturnIcon.jsx": 538,
	"./ui-kit/icons/RightArrowIcon": 294,
	"./ui-kit/icons/RightArrowIcon.jsx": 294,
	"./ui-kit/icons/SearchIcon": 295,
	"./ui-kit/icons/SearchIcon.jsx": 295,
	"./ui-kit/icons/XentralLogo": 290,
	"./ui-kit/icons/XentralLogo.jsx": 290,
	"./ui-kit/icons/copy": 369,
	"./ui-kit/icons/copy.js": 369,
	"./ui-kit/icons/delete_icon": 282,
	"./ui-kit/icons/delete_icon.js": 282,
	"./ui-kit/icons/dhl_logo": 284,
	"./ui-kit/icons/dhl_logo.js": 284,
	"./ui-kit/icons/green_dot": 518,
	"./ui-kit/icons/green_dot.js": 518,
	"./ui-kit/icons/klaviyo_logo": 287,
	"./ui-kit/icons/klaviyo_logo.js": 287,
	"./ui-kit/icons/logo_8returns": 285,
	"./ui-kit/icons/logo_8returns.js": 285,
	"./ui-kit/icons/red_dot": 517,
	"./ui-kit/icons/red_dot.js": 517,
	"./ui-kit/icons/shield": 575,
	"./ui-kit/icons/shield.js": 575,
	"./ui-kit/icons/shopify_logo": 286,
	"./ui-kit/icons/shopify_logo.js": 286,
	"./ui-kit/icons/shopware_logo": 288,
	"./ui-kit/icons/shopware_logo.js": 288,
	"./user/edit": 1012,
	"./user/edit.js": 1012,
	"./user/locales/DE.json": 803,
	"./user/locales/EN.json": 802,
	"./user/user.hook": 576,
	"./user/user.hook.js": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1075;